import { defineStore } from "pinia";
import axios from "axios";
// import { useToast } from "vue-toast-notification";

// const $toast = useToast();
// let instance = $toast.success('You did it!');

export const useAuthStore = defineStore("auth", {
    state: () => ({
        authUser: null,
        authErrors: [],
        authStatus: null,
        savingSuccessful: false,
        token: null,
        isAuth: false
    }),
    getters: {
        user: (state) => state.authUser,
        errors: (state) => state.authErrors,
        status: (state) => state.authStatus,
        isAuthenticated: state => state.isAuth
        // errors: (state) => state.authStatus
    },
    actions: {
        async getToken() {
            await axios.get('/sanctum/csrf-cookie');
            await axios.get('/sanctum/csrf-cookie');
        },
        async getUser() {
            await this.getToken();
            const data = await axios.get('/api/user');
            this.authUser = data.data
        },
        
        async handleLogin(data) {
            this.authErrors = [];
            await this.getToken();
            const remmeber = Math.random().toString(36).slice(2)
            try {
                await axios.post('/login', {
                    email: data.email,
                    password: data.password,
                    remember_token: remmeber
                })
                // this.isAuthenticated = true;
                localStorage.setItem("user-info", remmeber);
                this.router.push("/");
            } catch (error) {
                if (error.response.status === 422) {
                    this.authErrors = error.response.data.errors;
                }
            }
        },

        async handleRegister(data) {
            this.authErrors = [];
            await this.getToken();
            try {
                await axios.post('/register', {
                    name: data.name,
                    email: data.email,
                    password: data.password,
                    password_confirmation: data.password_confirmation,
                });
                // this.router.push("/");
            } catch (error) {
                if (error.response.status === 422) {
                    this.authErrors = error.response.data.errors;
                }
            }
        },

        async handleCreateUser(data) {
            this.authErrors = [];
            await this.getToken();
            try {
                await axios.post('/api/user/add', {
                    name: data.name,
                    email: data.email,
                    password: data.password,
                    password_confirmation: data.password_confirmation,
                });
                // this.router.push("/");
            } catch (error) {
                if (error.response.status === 422) {
                    this.authErrors = error.response.data.errors;
                }
            }
        },

        async handleComingSoon(data) {
            this.authErrors = [];
            await this.getToken();
            try {
                await axios.post('/coming/store', {
                    email: data.email,
                });
                // this.authStatus = response.data.status
                data.email = null,
                    this.savingSuccessful = 'شكرا لك، لقد تم إضافة بريدك إلى القائمة البريدية الخاصة بأساكيب، سنراسلك قريبا بإذن الله تعالى';
                // this.router.push("/");
            } catch (error) {
                if (error.response.status === 422) {
                    this.authErrors = error.response.data.errors;
                }
            }
        },
        async handleLogout() {
            await axios.post('/logout');
            this.authUser = null;
            localStorage.removeItem('user-info');
            this.router.push("/login")
        },
        async handleForgotPassword(data) {
            this.authErrors = [];
            await this.getToken();
            try {
                const response = await axios.post('/forgot-password', {
                    email: data.email,
                });
                this.authStatus = response.data.status
                // this.router.push("/");
            } catch (error) {
                if (error.response.status === 422) {
                    this.authErrors = error.response.data.errors;
                }
            }
        },
        async handleResetPass(restData) {
            this.authErrors = [];
            await this.getToken();
            try {
                const response = await axios.post(`/password-reset`, restData);
                this.authStatus = response.data.status
                this.router.push("/login");
            } catch (error) {
                if (error.response.status === 422) {
                    this.authErrors = error.response.data.errors;
                }
            }
        }

    },

})
